import { Box, Skeleton, Stack } from '@mui/material';

/** Placeholder rows shown while a tree / result list loads. */
export function SkeletonRows({ count = 6 }: { count?: number }) {
  return (
    <Stack spacing={0.5} sx={{ p: 1.5 }}>
      {Array.from({ length: count }).map((_, index) => (
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 0.75 }}>
          <Skeleton variant="rounded" width={18} height={18} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={`${40 + ((index * 13) % 45)}%`} height={14} />
            <Skeleton variant="text" width="70%" height={10} />
          </Box>
        </Box>
      ))}
    </Stack>
  );
}

export default SkeletonRows;
